import React from 'react'
import i18next from 'i18next'
import { DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'

interface LatePaymentProps {
  amountWithCurrency: string
  transactionHash: string
}

const LatePayment = ({ amountWithCurrency, transactionHash }: LatePaymentProps) => {
  return (
    <>
      {amountWithCurrency && (
        <DataListItem
          id="amount-with-currency"
          testId="amount-with-currency"
          title={i18next.t('transactions.sideBar.paymentInAmountReceived')}
          body={amountWithCurrency}
        />
      )}
      {transactionHash && (
        <DataListItem
          id="transaction-hash"
          testId="transaction-hash"
          title={i18next.t('hash')}
          body={ellipseMiddleText(transactionHash, 20, 10)}
          copyText={transactionHash}
        />
      )}
    </>
  )
}

export default LatePayment
